import { LinkColors, MyLink } from '@app/shared';
import { PageType, SizesType } from '../../module/types/catalogSchema';

import classNames from 'classnames';

import styles from './BlockSizes.module.scss';

export enum Mode {
  Tyres,
  Disks,
  AKB,
  TruckTires,
}

interface BlockSizesProps {
  sizes: SizesType;
  mode?: Mode;
  type?: PageType;
}

function lowercaseFirstLetter(text) {
  return text.charAt(0).toLowerCase() + text.slice(1);
}

export const BlockSizes = ({ sizes, mode = Mode.Tyres, type = PageType.Product }: BlockSizesProps) => {
  const isTyres = mode === Mode.Tyres;
  return (
    <div className={classNames(styles.Wrapper, { [styles.AKB]: mode === Mode.AKB })}>
      <div className={styles.Header}>
        <MyLink href={sizes.href} color={mode === Mode.AKB ? LinkColors.Red : LinkColors.Black}>
          {sizes.title}
        </MyLink>
      </div>
      <div className={styles.Line} />
      <div className={styles.Content}>
        {sizes.links.map(link => {
          return (
            <div className={classNames({ [styles.Colum]: isTyres })} key={link.href}>
              {isTyres && (
                <MyLink href={link.href + 'leto/'}>{type === PageType.Brand ? `Летние ${lowercaseFirstLetter(link.title)}` : 'Летняя'}</MyLink>
              )}
              <MyLink href={link.href}>{link.title}</MyLink>
              {isTyres && (
                <MyLink href={link.href + 'zima/'}>{type === PageType.Brand ? `Зимние ${lowercaseFirstLetter(link.title)}` : 'Зимняя'}</MyLink>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
